import { Col, Form, FormInstance, FormProps, Input, InputNumber, Row } from "antd";
import { forwardRef } from "react";
import { CorrecaoContabil } from "../../../../../Models/Domain/Viagem/Financeiro/CorrecaoContabil";
import PlanoDeContasSelect from "../../../Financeiro/PlanoDeContas/PlanoDeContasSelect";
import { EnumPlanoContasTipoMovimentacao } from "../../../../../Models/Financeiro/PlanoContasTipo";
import { EnumRegistroTipo } from "../../../../../Models/Financeiro/PlanoContasTipoRegistro";
import { BooleanProps } from "../../../../../utility-types";
import ViagemSelect from "../../ViagemSelect";
import PessoaSelectComTipo from "../../../Pessoa/PessoaSelect";
import { EnumPessoaTipo } from "../../../../../Models/Pessoa/Pessoa";
import InputDate from "../../../../Base/Input/InputDate";
export interface ICorrecaoContabilFormBasicRef extends FormInstance<CorrecaoContabil> {

};
interface ICorrecaoContabilFormBasicProps extends FormProps<CorrecaoContabil> {
    codigo?:number,
    fieldsDisabled?:BooleanProps<CorrecaoContabil>
}

const CorrecaoContabilFormBasic = forwardRef<ICorrecaoContabilFormBasicRef, ICorrecaoContabilFormBasicProps>(function CorrecaoContabilFormBasic(
    {
        codigo,
        form : formParam,
        disabled,
        component,
        layout,
        autoComplete,
        fieldsDisabled,
        ...props
    },
    ref
) {
    const [newForm] = Form.useForm<CorrecaoContabil>();
    const form = formParam ?? newForm;
    
    return <Form<CorrecaoContabil>
        ref={ref}
        form={form}
        disabled={disabled}
        component={component ?? "div"}
        layout={layout ?? "vertical"}
        autoComplete={autoComplete ?? "off"}
        {...props}
    >
        <Row gutter={8} wrap>
            <Form.Item<CorrecaoContabil> name={"codigo"} hidden></Form.Item>
            <Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={6}>
                <Form.Item<CorrecaoContabil>
                    name={"codViagem"}
                    label={"Viagem"} 
                    rules={[{ required : true, message : "Por favor, selecione uma viagem" }]}
                >
                    <ViagemSelect 
                        disabled={fieldsDisabled?.codViagem} 
                    />
                </Form.Item>
            </Col>

            <Col xs={24} sm={12} md={12} lg={16} xl={18} xxl={18}>
                <PessoaSelectComTipo<CorrecaoContabil>
                    tiposPessoaValidos={undefined}
                    tiposPessoaInValidos={[EnumPessoaTipo.EMPRESA]}
                    names={{
                        tipo: ["beneficiario", "tipo"],
                        "*": ["codBeneficiario"],
                    }}
                    rules={{
                        tipo: [{ required: true }],
                        "*": [{ required: true, message: "Por favor, selecione um beneficiário" }],
                    }}
                />
            </Col>

            <Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={6}>
                <Form.Item<CorrecaoContabil>
                    name={"planoContas"}
                    label={"Plano de contas"} 
                    rules={[{ required : true, message : "Por favor, selecione um plano de contas" }]}
                >
                    <PlanoDeContasSelect 
                        filtros={{
                            tipo : {
                                codigo : EnumPlanoContasTipoMovimentacao.Receita
                            },
                            tipoRegistro : {
                                codigo : EnumRegistroTipo.Item
                            }
                        }}
                    />
                </Form.Item>
            </Col>

            <Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
                <Form.Item<CorrecaoContabil>
                    name={"dataPagamento"}
                    label={"Data pagamento"}
                    rules={[{ required : true }]}
                >
                    <InputDate />
                </Form.Item>
            </Col>          

            <Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
                <Form.Item<CorrecaoContabil> 
                    name={"valor"}
                    label={"Valor (R$)"}
                    rules={[{ required : true }]}
                >
                    <InputNumber<number> style={{ width: "100%" }} precision={2} controls={false} placeholder="Valor (R$)" />
                </Form.Item>
            </Col>

            <Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
                <Form.Item<CorrecaoContabil> 
                    name={"comprovante"}
                    label={"Comprovante"}
                    rules={[{ required : true, max : 32 }]}
                >
                    <Input placeholder="Comprovante"></Input>
                </Form.Item>
            </Col>
            
            <Col xs={24}>
                <Form.Item<CorrecaoContabil> 
                    name={"urlComprovante"}
                    label={"URL Comprovante"}
                    rules={[ { required : false, max : 300,  type : "url" } ]}
                >
                    <Input 
                        maxLength={500}
                        placeholder="URL Comprovante" 
                        style={{ width: "100%" }}
                        allowClear={true}
                    ></Input>
                </Form.Item>
            </Col>
        </Row>
    </Form>;
});
export default CorrecaoContabilFormBasic;